import {createSelector} from "@reduxjs/toolkit";

import {selectValueOrders} from "./valueOrdersSlice";

/**
 * Selector for all Value orders, which are not of type "Reva" (ordered by relevance).
 */
export const selectExternalValueOrders = createSelector([selectValueOrders], (valueOrders) =>
    valueOrders.filter((order) => order.orderType !== "Reva"),
);

/**
 * Selector for Value Order with the highest relevance (can be a "Reva" order or an "external" order).
 */
export const selectMostRelevantValueOrder = createSelector(
    [selectValueOrders],
    (valueOrders) => valueOrders[0] ?? null,
);

/**
 * Selector for ExternalOrderNumber of the Value Order with the highest relevance (can be a "Reva" order or an "external" order).
 */
export const selectMostRelevantExternalOrderNumber = createSelector(
    [selectMostRelevantValueOrder],
    (valueOrder) => valueOrder?.valueExternalOrderNumber ?? null,
);

/**
 * Selector for OrderDetails of the Value Order with the highest relevance (can be a "Reva" order or an "external" order).
 */
export const selectMostRelevantOrderDetails = createSelector(
    [selectMostRelevantValueOrder],
    (valueOrder) => valueOrder?.orderDetails ?? null,
);

/**
 * Selector for Order Data of the Value Order of Type "Inspection" (with the highest relevance), or null if no inspection order is attached.
 */
export const selectInspectionOrderData = createSelector(
    [selectValueOrders],
    (valueOrders) => valueOrders.filter((order) => order.orderType === "Inspection")[0] ?? null,
);

/**
 * Selector to check whether a Value Order of Type "Inspection" is attached.
 */
export const selectHasInspectionOrder = createSelector(
    [selectValueOrders],
    (valueOrders) => valueOrders.filter((order) => order.orderType === "Inspection").length > 0,
);
